import axios from "axios";

// const API_URL = 'http://localhost/games/bin_toss_admin/api/ScoreApi.php';
const API_URL = process.env.REACT_APP_PHP_SCORE_ADD_URL; // update to your PHP path
console.log("API_URL",API_URL);


// Insert Score (PHP checks for duplicate automatically)
export const insertScore = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "insert",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Insert error:", err);
    return { status: "error", message: err.message };
  }
};
export const alreadyPlayed = async (data) => {
  try {
    const response = await axios.post(
      API_URL,
      {
        action: "check",
        ...data,
      },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    // 🔹 If backend returns nothing or false
    if (!response.data) {
      return null; // means not played → print nothing
    }

    return response.data;

  } catch (err) {
    console.error("AlreadyPlayed error:", err);
    return null;
  }
};
// Update lives (no need for record id anymore)
export const updateLives = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "updateLives",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

// Update Score (no need for record id anymore)
export const updateScore = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "update",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};
// Update Score (no need for record id anymore)
export const updateReport = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "updatereport",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const fetchQuestions = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "fetchQuestions",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const fetchCurrentQuestion = async (data) => {
  try {
    const response = await axios.post(API_URL, {
      action: "fetchCurrentQuestion",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const updategameover = async (data) => {
  try {
    const response = await axios.post(API_URL, {
        action: "updategameover",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};

export const getScore  = async (data) => {
  try {
    const response = await axios.post(API_URL, {
        action: "getScore",
      ...data,
    }, {
      headers: { "Content-Type": "application/json" },
    });

    return response.data;
  } catch (err) {
    console.error("Update error:", err);
    return { status: "error", message: err.message };
  }
};